import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; // Import BrowserRouter
import Home from './components/pages/Home';
import { LanguageProvider } from './components/language/LanguageProvider';
import { NavigationProvider } from './components/pageComponents/NavigationContext';
import * as Constants from './Constants';
import ImagePage from './components/pages/ImagePage';
import BiographyPage from './components/pages/BiographyPage';
import 'react-photo-view/dist/react-photo-view.css';
import ContactPage from './components/pages/ContactPage';
import TextPage from './components/pages/TextPage';
import ScrollToTop from './components/hooks/ScrollToTop';

function App() {

  return (
    <div id='website-wrapper' >
      <LanguageProvider>
        <NavigationProvider>
          <BrowserRouter>
            <ScrollToTop> 
              <Routes>
                <Route path="/" element={<Home />} />
                {/* Malerei */}
                <Route path={Constants.TWO_THOUSAND_TEN_TO_TWO_THOUSAND_TWENTY_FIVE_ROUTE} element={<ImagePage />}/>
                <Route path={Constants.NINETEEN_NINETY_TO_TWO_THOUSAND_NINE_ROUTE} element={<ImagePage />}/>
                <Route path={Constants.NINETEEN_EIGHTY_TO_NINETEEN_NINETY_ROUTE} element={<ImagePage />}/>
                {/* Papier */}
                <Route path={Constants.GRAPHIC_ROUTE} element={<ImagePage />}/>
                <Route path={Constants.DRAWING_ROUTE} element={<ImagePage />}/>
                <Route path={Constants.ACRYL_ROUTE} element={<ImagePage />}/>
                {/* Realstudien */}
                <Route path={Constants.TRAVEL_ROUTE} element={<ImagePage />}/>
                <Route path={Constants.PORTRAIT_ROUTE} element={<ImagePage />}/>
                {/* Texte */}
                <Route path={Constants.HANS_ZITKO_ROUTE} element={<TextPage />}/>
                <Route path={Constants.TIM_SOMMER_ROUTE} element={<TextPage />}/>
                <Route path={Constants.CONSTANZE_TREUNER_ROUTE} element={<TextPage />}/>
                <Route path={Constants.SIMONE_TIPPACH_SCHNEIDER_ROUTE} element={<TextPage />}/>

                <Route path={Constants.BIOGRAPHY_ROUTE} element={<BiographyPage />}/>
                <Route path={Constants.CONTACT_ROUTE} element={<ContactPage />}/>

                
              </Routes>
            </ScrollToTop>
          </BrowserRouter>
        </NavigationProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
